import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  getIsVerified,
  setIsVerified as setIsVerifiedStorage,
  getIsFillProfile,
  setIsFillProfile as setIsFillProfileStorage,
  getHasVek,
  setHasVek as setHasVekStorage
} from "./verificationStorage";

import { registerAuthHandlers } from "./authBridge.js";
import { badRequestMessage } from "@/messages";
import { api } from "@/api/axios"; // ДОБАВЛЕНО: импорт API

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isVerified, setIsVerified] = useState(() => getIsVerified());
  const [isVerificationLoading, setIsVerificationLoading] = useState(() => !getIsVerified());
  const [isFillProfile, setIsFillProfile] = useState(() => getIsFillProfile());
  const [hasVek, setHasVek] = useState(() => getHasVek());

  // ДОБАВЛЕНО: Роль и состояние загрузки
  const [role, setRole] = useState('USER');
  const [isUserLoading, setUserLoading] = useState(true);

  const [isShowWarning, setIsShowWarning] = useState(false);
  const [messageWarning, setMessageWarning] = useState({ title: '', description: '' });
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  // ДОБАВЛЕНО: Загрузка данных пользователя (получение роли с бэка)
  const refreshUser = async () => {
    try {
      setUserLoading(true);
      const res = await api.post('/gates/data/get_user_data', {});
      const data = res.data;
      
      setIsVerified(!!data.USER_CONFIRMED);
      setIsFillProfile(!!data.PROFILE_SAVE);
      setRole(data.ROLE || 'USER');
      
      if (data.EMAIL) {
        localStorage.setItem('email', data.EMAIL);
      }
      if (data.LOGIN) {
        localStorage.setItem('login', data.LOGIN);
      }
      if (data.HAS_VEK !== undefined) {
        setHasVek(data.HAS_VEK);
      }
    } catch(e) {
      console.error('Ошибка загрузки данных пользователя:', e);
    } finally {
      setUserLoading(false);
    }
  };

  // ДОБАВЛЕНО: Вызов refreshUser при загрузке
  useEffect(() => {
    refreshUser();
  }, []);

  useEffect(() => {
    setIsVerifiedStorage(isVerified);
  }, [isVerified]);

  useEffect(() => {
    setIsFillProfileStorage(isFillProfile);
  }, [isFillProfile]);

  useEffect(() => {
    setHasVekStorage(hasVek);
  }, [hasVek]);

  useEffect(() => {
    registerAuthHandlers({
      showError: () => {
        setNotification({ open: true, message: badRequestMessage, severity: 'error' });
      },
    });
  }, []);

  const resetUserSession = () => {
    setIsVerified(false);
    setIsFillProfile(false);
    setHasVek(null);
    
    // ДОБАВЛЕНО: сброс роли и лоадера
    setRole('USER');
    setUserLoading(false);

    localStorage.removeItem('isVerified');
    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('hasVek');
    localStorage.removeItem('email');
    localStorage.removeItem('login');
  }

  const value = useMemo(
    () => ({
      isVerified,
      setIsVerified,
      isVerificationLoading,      
      setIsVerificationLoading,
      isFillProfile,
      setIsFillProfile,
      hasVek,
      setHasVek,
      role,       
      setRole,    
      isUserLoading,
      refreshUser, // ДОБАВЛЕНО
      isShowWarning,
      setIsShowWarning,
      messageWarning,
      setMessageWarning,
      notification,
      setNotification,
      resetUserSession
     }),
    [isVerified, isVerificationLoading, isFillProfile, hasVek, role, isUserLoading, isShowWarning, messageWarning, notification]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);